import { IMessageContentTypeBubble } from "../../MessagePanel";
import {
  MESSAGE_CONTENT_DOCUMENT_TYPE,
  MESSAGE_STATUS,
} from "@home-health-notify/domain";
import PDFSvg from "../../../assets/images/document/PDF.svg";
import theme from "../../../theme";
import XLSSvg from "../../../assets/images/document/XLS.svg";
import DOCSvg from "../../../assets/images/document/DOC.svg";
import DEFAULTSvg from "../../../assets/images/document/DEFAULT.svg";
import {
  DocumentContentIcon,
  DocumentContentText,
  DocumentContentWrapper,
  DocumentTextWrapper,
} from "./DocumentContent.style";
import { Button } from "@mui/material";
import React from "react";
import ExpandableText from "../../../common/ExpandableText";

const DocumentContent = ({
  message,
  openMediaDialog,
}: IMessageContentTypeBubble) => {
  let messageData = message.getMessage();
  const isPendingMessage = messageData.status === MESSAGE_STATUS.PENDING;
  return (
    <>
      {(messageData.documents ?? []).map((document, i) => {
        const documentTypeMap = {
          [MESSAGE_CONTENT_DOCUMENT_TYPE.PDF]: {
            style: theme.document.pdf,
            icon: PDFSvg,
          },
          [MESSAGE_CONTENT_DOCUMENT_TYPE.XLS]: {
            style: theme.document.xls,
            icon: XLSSvg,
          },
          [MESSAGE_CONTENT_DOCUMENT_TYPE.XLSX]: {
            style: theme.document.xls,
            icon: XLSSvg,
          },
          [MESSAGE_CONTENT_DOCUMENT_TYPE.DOC]: {
            style: theme.document.doc,
            icon: DOCSvg,
          },
        };
        let documentMap = documentTypeMap[document.docType];
        if (!documentMap) {
          documentMap = {
            style: theme.document.default,
            icon: DEFAULTSvg,
          };
        }
        return (
          <React.Fragment key={document.url + i}>
            <DocumentContentWrapper
              key={document.url + i}
              sx={{
                ...documentMap.style,
              }}
            >
              <Button
                onClick={() => !isPendingMessage && openMediaDialog?.(message)}
                sx={{
                  justifyContent: "flex-start",
                  width: "100%",
                }}
              >
                <DocumentContentIcon
                  src={documentMap.icon}
                  alt={document.docType}
                />
                <DocumentTextWrapper>
                  <DocumentContentText variant="body2">
                    {document.docType} - {document.size}
                  </DocumentContentText>
                </DocumentTextWrapper>
              </Button>
            </DocumentContentWrapper>
            <ExpandableText> {document.text}</ExpandableText>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default DocumentContent;
